import React from 'react'

export default function StakeTabTwo() {
  return (
    <div>StakeTabTwo</div>
  )
}
